import './Badge.css';

export interface BadgeProps {
  /**
   * 상태 넷(success · warning · danger · info)은 **F4 의 tint/ink 짝**이다 — 옅은 바탕에 진한 글자.
   * ★ `count` 는 **다른 것**이다(정본 D4-6) — 알림 개수처럼 «크게 외치는» 자리라 채운 빨강이다.
   *   상태를 나타내려고 `count` 를 쓰지 않는다.
   */
  variant?: 'default' | 'primary' | 'success' | 'warning' | 'danger' | 'info' | 'count';
  size?: 'sm' | 'md';
  children: React.ReactNode;
}

export function Badge({ variant = 'default', size = 'md', children }: BadgeProps) {
  return <span className={`badge badge-${variant} badge-${size}`}>{children}</span>;
}
